// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finalElement{background:green}.finalElement,.pending{border-radius:5px;padding:4px;color:#fff;font-weight:800}.pending{background:orange}", ""]);
// Exports
module.exports = exports;
